<template>
	<section class="events">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<!-- desktop -->
					<div
						v-for="event in $store.state.events.events.results"
						class="events__stripe-wrapper events__stripe-wrapper--desktop"
						@click="handleEventClick($event, event.id)"
					>
						<div class="events__stripe events__stripe--short events__stripe--range"
							 :class="{'events__stripe--national': event.rank === 'national',
							 'events__stripe--international': event.rank === 'international',
							 'events__stripe--club': event.rank === 'club'}">
							<span>{{event.rank}}</span>
						</div>

						<div class="events__stripe events__stripe--short events__stripe--date">
							<span v-if="event.breed_judging_date" class="events__stripe--year">{{event.breed_judging_date}}</span>
							<span v-if="!event.breed_judging_date" class="events__stripe--month">{{getDateRange(event.date, event.date_to)}}</span>
							<span v-if="!event.breed_judging_date" class="events__stripe--year">{{getYear(event.date, event.date_to)}}</span>
						</div>

						<div class="events__stripe events__stripe--long events__stripe--white">
							<div class="events__stripe--location">
								<img class="events__stripe--icon" src="/static/img/mark.svg" alt="">
								<div class="events__stripe--location-wrapper">
									<span class="events__stripe--place">{{event.city.name}}</span>
									<span class="events__stripe--place">{{event.city.country.name}}</span>
								</div>
							</div>

							<div v-if="$store.state.events.allowedLocation">
								<span v-if="!event.distance" class="events__stripe--distance">0 km</span>
								<span v-if="event.distance" class="events__stripe--distance">{{getDistance(event.distance)}} km</span>
							</div>
						</div>

						<div class="events__stripe events__stripe--long events__stripe--silver events__stripe--title-wrapper">
							<span class="events__stripe--title">{{event.name}}</span>
						</div>

						<div class="events__stripe events__stripe--long events__stripe--white events__stripe--judges-wrapper">
							<div class="events__stripe--hammer-wrapper">
								<img class="events__stripe--icon-hammer" src="/static/img/hammer.svg" alt="">
								<router-link
                                        v-if="event.judges_names[0]"
                                        :to="{name: 'Event', params: { id: event.id }, query: {page: $store.state.events.events.currentPage, judges: 'all'}}"
                                        class="events__stripe--btn events__judge"
                                >
                                    {{$t('events.stripes.all')}}
                                </router-link>
							</div>

							<div class="events__stripe--judges">
								<span v-for="judge in event.judges_names" class="events__stripe--judge">
									{{judge}}
								</span>
								<router-link
                                        v-if="!event.judges_names[0]"
                                        :to="{name: 'JudgesList'}"
                                        class="events__stripe--btn events__stripe--judge events__judge">
                                    {{$t('events.stripes.judges')}}
                                </router-link>
							</div>
						</div>

						<div v-if="$store.state.user.isLogged" @click="addFavEvent($event, event)" class="events__stripe events__stripe--short events__stripe--fav">
							<img v-if="event.is_favourite" src="/static/img/star-gold.svg" alt="">
							<img v-if="!event.is_favourite" src="/static/img/star-white.svg" alt="">
						</div>

						<a v-if="!$store.state.user.isLogged" @click="goToCreateAccount($event, event)" class="events__stripe events__stripe--short events__stripe--fav">
							<img src="/static/img/star-white.svg" alt="">
						</a>
					</div>
					<!-- e/o desktop -->

					<!-- mobile -->
					<div
						v-for="event in $store.state.events.events.results"
						class="events__stripe-wrapper events__stripe-wrapper--mobile"
						@click="handleEventClick($event, event.id)"
					>
						<div class="events__stripe events__stripe--range"
							 :class="{
                                 'events__stripe--national': event.rank === 'national',
                                 'events__stripe--international': event.rank === 'international',
                                 'events__stripe--club': event.rank === 'club'
                                 }"
                        >
							<span>{{event.rank}}</span>
						</div>

						<div class="events__stripe events__stripe-main">

							<div class="events__stripe events__stripe--date">
								<span class="events__stripe--month">{{getDateRange(event.date, event.date_to)}}</span>
								<span class="events__stripe--year">{{getYear(event.date, event.date_to)}}</span>
							</div>

							<div class="events__stripe events__stripe--location">
								<div>
									<img class="events__stripe--icon" src="/static/img/mark.svg" alt="">
									<span class="events__stripe--place">
                                        {{shortLocation(event.city.name)}} / {{shortLocation(event.city.country.name)}}
                                    </span>
								</div>
								<div v-if="$store.state.events.allowedLocation">
									<span v-if="!event.distance" class="events__stripe--distance">
                                        >>0 km
                                    </span>
									<span v-else class="events__stripe--distance">
                                        >>{{getDistance(event.distance)}} km
                                    </span>
								</div>
							</div>


							<div class="events__stripe events__stripe--judge">
								<img class="events__stripe--icon-hammer" src="/static/img/hammer.svg" alt="">
								<div class="events__stripe--judges">
									<span v-if="event.judges_names[0]" class="events__stripe--judge">{{event.judges_names[0]}}</span>
									<router-link v-if="!event.judges_names[0]" :to="{name: 'JudgesList'}" class="events__stripe--btn events__stripe--judge events__judge">See all judges</router-link>
								</div>
							</div>

							<div class="events__stripe events__stripe--name">
								<span class="events__stripe--title">{{event.name}}</span>
							</div>


							<div
                                    v-if="$store.state.user.isLogged"
                                    @click="addFavEvent($event, event)"
                                    class="events__stripe events__stripe--fav"
                            >
								<img v-if="event.is_favourite" src="/static/img/star-gold.svg" alt="">
								<img v-if="!event.is_favourite" src="/static/img/star-empty.svg" alt="">
							</div>
							<a
                                    v-else
                                    @click="goToCreateAccount($event, event)"
                                    class="events__stripe events__stripe--fav"
                            >
								<img src="/static/img/star-empty.svg" alt="">
							</a>
						</div>

					</div>
					<!-- e/o mobile -->

					<h3 v-if="!$store.state.events.events.results[0]">{{$t('noResults')}}</h3>
					<PaginationComponent :count="$store.state.events.events.count"
										 :currentPage="$store.state.events.events.currentPage"
										 @pageChanged="fetchEvents">
					</PaginationComponent>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import PaginationComponent from '../PaginationComponent'
	import { mapActions } from 'vuex'
	import axios from 'axios'
	import { getDateRange, getYear } from '@/assets/js/date.js'
	export default {
		components: {
			PaginationComponent
		},
		data () {
			return {
				events: []
			}
		},
		methods: {
			...mapActions(['fetchEvents']),
			getDateRange,
			getYear,
			getDistance (dist) {
				return Math.round(dist)
			},
			addFavEvent (evt, event) {
				evt.stopPropagation()

				if (!event.is_favourite) {
					let data = {
						event: event.id
					}
					axios.post('/api/events/favourites/', data, {
						headers: {
							'accept': 'application/json'
						}
					})
						.then(() => {
							this.fetchEvents()
						})
						.catch(error => {
							console.log(error)
						})
				} else {
					axios.delete(`/api/events/favourites/${ event.id }/`, {
					})
						.then(() => {
							this.fetchEvents()
						})
						.catch(error => {
							console.log(error)
						})
				}
			},
			goToCreateAccount (evt) {
				evt.stopPropagation()
				this.$router.push({name: 'CreateAccount'})
			},
			handleEventClick (event, id) {
				if (!event.target.matches('.events__judge')) {
					this.$router.push({
						name: 'Event',
						params: { id },
						query: {page: this.$store.state.events.events.currentPage}
					})
				}
			},
			shortLocation (name) {
				const maxLength = 9
				if (name.length > 9) {
					return name.substr(0, maxLength) + '...'
				} else {
					return name
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.events {
		padding-top: 40px;
		background-color: $gray-light;
		&__stripe-wrapper {
			align-items: center;
			width: 100%;
			height: 70px;
			margin-bottom: 25px;

			cursor: pointer;
			a {
				text-decoration: none;
			}
			&:nth-of-type(10) {
				margin-bottom: 40px;
			}
			&--desktop {
				display: flex;
			}
			&--mobile {
				display: none;
			}
		}
		&__stripe {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			font-family: $lato;
			font-size: 16px;
			color: $black;
			&--short {
				width: 105px;
			}
			&--long {
				width: 285px;
				justify-content: space-between;
				padding: 0 15px;
			}
			&--white {
				background-color: #fff;
			}
			&--silver {
				background-color: $silver;
			}
			&--fav {
				cursor: pointer;
				background-color: $fav;
				width: 87px;
			}
			&--range {
				font-family: $lato-bold;
				font-size: 14px;
				color: #fff;
				width: 126px;
			}
			&--national {
				background-color: $national;
			}
			&--international {
				background-color: $international;
			}
			&--club {
				background-color: $club;
			}
			&--date {
				flex-flow: column;
				justify-content: center;
				align-items: center;
				background-color: $silver;
			}
			&--year {
				display: inline;
				font-family: $lato-bold;
				font-size: 13px;
				line-height: 20px;
			}
			&--location {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			&--location-wrapper {
				display: flex;
				flex-flow: column;
				justify-content: center;
				align-items: flex-start;
			}
			&--icon {
				margin-right: 15px;
			}
			&--icon-hammer {
				margin-bottom: 5px;
			}
			&--place {
				font-size: 14px;
			}
			&--distance {
				font-size: 14px;
				font-family: $lato-bold;
				line-height: 73px;
			}
			&--title-wrapper {
				padding: 0 10px 0 15px;
			}
			&--title {
				text-align: left;
				line-height: 19px;
				font-size: 13px;
				color: $black;
			}
			&--hammer-wrapper {
				display: flex;
				flex-flow: column;
				align-items: center;
				margin-right: 15px;
			}
			&--btn {
				display: block;
				font-size: 10px;
				font-style: italic;
				text-decoration: underline !important;
				color: $black;
			}
			&--judges-wrapper {
				justify-content: flex-start;
			}
			&--judges {
				display: flex;
				flex-flow: column;
				align-items: flex-start;
			}
			&--judge {
				font-family: $lato-bold;
				font-size: 13px;
			}
		}
	}

	@media (max-width: 991.98px) {
		.events {
			&__stripe-wrapper {
				align-items: center;
				width: 100%;
				height: 115px;
				margin-bottom: 25px;
				&:nth-of-type(10) {
					margin-bottom: 25px;
				}
				&--desktop {
					display: none;
				}
				&--mobile {
					display: flex;
				}
			}
			&__stripe {
				height: 100%;
				font-size: 16px;
				&-main {
					position: relative;
					flex-flow: column;
					background: #fff;
					padding: 15px 20px 15px 10px;
					width: 95%;
				}
				&--range {
					font-size: 10px;
					width: 5%;
					span {
						line-height: 15px;
						transform: rotate(-90deg);

					}
				}
				&--date {
					flex-flow: row;
					justify-content: flex-start;
					align-items: center;
					background-color: #fff;
					width: 100%;
					color: $gold-score;
				}
				&--month {
					font-family: $lato-bold;
					font-size: 16px;
					margin-right: 5px;
				}
				&--year {
					display: block;
					font-family: $lato-bold;
					font-size: 11px;
					align-self: flex-end;
					line-height: 14px;
				}
				&--location {
					width: 100%;
					justify-content: space-between;
				}
				&--icon {
					width: 10px;
					height: 10px;
					margin-right: 5px;
				}
				&--place {
					font-family: $lato;
					font-size: 13px;
				}
				&--distance {
					line-height: normal;
				}
				&--judge {
					width: 100%;
					justify-content: flex-start;
					font-size: 13px;
					font-family: $lato;
					margin-bottom: 3px;
				}
				&--icon-hammer {
					width: 10px;
					height: 10px;
					margin: 0;
					margin-right: 5px;
				}
				&--name {
					width: 100%;
					justify-content: flex-start;
				}
				&--title {
					line-height: normal;
					font-size: 10px;
				}
				&--fav {
					width: 20px;
					height: 20px;
					position: absolute;
					top: 10px;
					right: 10px;
					background: #fff;
				}
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/EventsList/EventsComponent.vue